<template>
	<!-- Modal -->
	<div class="modal fade" id="createQuestionnaireModal" tabindex="-1" aria-labelledby="addEditModalLabel" aria-hidden="true">
		<form @submit.prevent="form.index != null ? updateSection() : addSection()">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="addEditModalLabel">
                            {{ form.index ? __('questionnaires.section-edit') : __('questionnaires.section-add') }}
                        </h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<div class="mb-3">
							<label for="name" class="form-label">{{ __('questionnaires.section-title') }}</label>
							<input type="text" class="form-control" v-model="form.title" id="name" required>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{ __('actions.close') }}</button>
						<button type="submit" class="btn btn-primary">{{ __('actions.submit') }}</button>
					</div>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
export default {
	data() {
		return {
			form: {
				title: null,
				index: null,
			}
		}
	},

	methods: {
		addSection: function () {
			let data = new FormData
			data.title = this.form.title

			this.$emit('new-section', data)
		},

		updateSection: function () {
			let data = new FormData
			data.title = this.form.title
			data.index = this.form.index

			this.$emit('update-section', data)
		},

		closeModal: function () {
			const myModalEl = document.querySelector('#createQuestionnaireModal')
			const modal = bootstrap.Modal.getOrCreateInstance(myModalEl)
			modal.hide()
			this.form.title = null
			this.form.index = null
		},

		editSection: function (title, index) {
			this.form.title = title
			this.form.index = index
			const myModalEl = document.querySelector('#createQuestionnaireModal')
			const modal = bootstrap.Modal.getOrCreateInstance(myModalEl)
			modal.show()
		}
	}
}
</script>
